var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,1a5,5,0,1,0,5,5A5,5,0,0,0,6,1ZM6,9.889A3.889,3.889,0,1,1,9.889,6,3.889,3.889,0,0,1,6,9.889Z",
    transform: "translate(0 0)",
    fill: "#696969"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.111,7.548V5.556A.556.556,0,0,0,9,5.556V7.778a.555.555,0,0,0,.163.393l1.111,1.111A.556.556,0,1,0,11.06,8.5Z",
    transform: "translate(-3.556 -1.223)",
    fill: "#696969"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/clock_icon.f52a994cbf1b1f6b2053224152a1a29f.svg";
export { ForwardRef as ReactComponent };